import { inject, ModuleWithProviders, NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ServiceWorkerModule, SwRegistrationOptions } from "@angular/service-worker";
import { ServiceWorkerVersionControlService } from "./service-worker-version-control.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ServiceWorkerVersionInterceptor } from "./service-worker-version-interceptor.service";
import { FirebaseCloudMessagingService } from "./firebase-cloud-messaging.service";
import { ServiceWorkerMessageListener } from './service-worker-message-listener.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ServiceWorkerModule.register("ngsw-worker.js")
  ],
  providers: [
    ServiceWorkerVersionControlService,
    ServiceWorkerMessageListener,
    FirebaseCloudMessagingService

  ]
})
export class ServiceWorkerManagementModule{
  readonly d = {}

  private static serviceWorkerEnabled: string | undefined = undefined;
  private serviceWorkerMessageListener = inject(ServiceWorkerMessageListener);

  constructor() {
    this.serviceWorkerMessageListener.listenForServiceWorker(ServiceWorkerManagementModule.serviceWorkerEnabled);
  }

  static forRoot(serviceWorkerEnabled: any): ModuleWithProviders<ServiceWorkerManagementModule> {
    this.serviceWorkerEnabled = serviceWorkerEnabled;
    return {
      ngModule: ServiceWorkerManagementModule,
      providers: [
        {
          provide: SwRegistrationOptions, useValue: {
            enabled: serviceWorkerEnabled,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: "registerWhenStable:30000"
          },
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ServiceWorkerVersionInterceptor,
          multi: true
        }
      ]
    };
  }

}
